<div>
    <canvas baseChart
            [datasets]="datasets"
            [options]="chartOptions"
            chartType="scatter">
    </canvas>
</div>
